import React, { Component } from 'react';
import Dashboard from './dashboard';
import { connect } from 'react-redux';
import OldHomePage from './OldHomePage';
import {
  getOrders,
  getCashDrawer,
  getSales,
  getTopProductsSales,
  getTopMembers,
  getTopSellers,
  getTimesheet,
  getPurchaseOrdersDb,
  getInvetory,
  getCampaignDb
} from 'actions/DashboardActions';
import { getSellableProducts, setProductListEmpty, getUserRolePageByName } from 'actions/EntityActions';
import * as idb from 'config/db';
import 'styles/sass/home/index.scss';
import { getUserBranches, selectStore } from '../../../actions/CommonActions';

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topProductSales: {
        periodFilter: 'month'
      },
      sales: {
        periodFilter: 'week'
      },
      topSellers: {
        periodFilter: 'month'
      },
      inventory: {
        categoryFilter: 0
      },
      branchId: null,
      active: false
    }

    this.handleTopProductSalesFilter = this.handleTopProductSalesFilter.bind(this);
    this.handleTopSellersFilter = this.handleTopSellersFilter.bind(this);
    this.handleSalesFilter = this.handleSalesFilter.bind(this);
    this.handleInventoryFilter = this.handleInventoryFilter.bind(this);
  }

  componentDidMount() {
    if (this.props.branchId) {
      this.init();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.branchId !== null && prevProps.branchId !== this.props.branchId) {
      this.updateBranch();
    }

    if (this.props.cachingProducts && this.props.cachingProducts != prevProps.cachingProducts) {
      this.props.getSellableProducts({
        page: 0,
        searchText: "",
        baseCategoryId: null,
        categoryId: null,
        branchId: this.props.branchId,
        THC_MIN: 0,
        THC_MAX: 100,
        CBD_MIN: 0,
        CBD_MAX: 100,
        SubCategoryId: [],
        Weight: []
      });
    }

    if (this.props.sellableProducts && this.props.sellableProducts != prevProps.sellableProducts) {
      this.cacheProducts();
    }
  }

  init = async () => {
    let branchId = this.props.branchId;
    let Category = this.state.inventory.categoryFilter;

    this.props.selectStore();
    this.props.getUserBranches(this.props.userName);
    const userRole = this.props.authUser.roles;
    this.props.getUserRolePageByName(userRole[0]);

    this.props.getOrders(branchId);
    this.props.getCashDrawer(branchId);
    this.getSales();
    this.getTopProductsSales();
    // this.props.getTopMembers(branchId); this is not used
    this.getTopSellers();
    this.props.getTimesheet(branchId);
    this.props.getPurchaseOrdersDb(branchId);
    this.props.getInvetory({ branchId, Category });
    this.props.getCampaignDb(branchId);
  }

  cacheProducts = async () => {
    const productSchema = Object.keys(this.props.sellableProducts[0]).join(', ');
    await idb.init(productSchema);
    idb.product.addItems(this.props.sellableProducts);
    this.props.setProductListEmpty();
  }

  updateBranch = () => {
    this.setState(prevState => {
      return {
        ...prevState,
        branchId: this.props.branchId
      }
    }, () => this.init());
  }

  /* SALES  */
  getSales() {
    this.props.getSales({
      branchId: this.props.branchId,
      periodFilter: this.state.sales.periodFilter
    });
  }

  getInvetory() {

    this.props.getInvetory({
      branchId: this.props.branchId,
      Category: this.state.inventory.categoryFilter
    })
  }

  handleSalesFilter(value) {
    this.setState(prevState => {
      return {
        sales: {
          ...prevState.sales,
          periodFilter: value
        }
      }
    }, () => this.getSales());
  }

  /* TOP PRODUCT SALES  */

  getTopProductsSales() {
    this.props.getTopProductsSales({
      branchId: this.props.branchId,
      periodFilter: this.state.topProductSales.periodFilter
    });
  }

  handleTopProductSalesFilter(value) {
    this.setState(prevState => {
      return {
        ...prevState,
        topProductSales: {
          ...prevState.topProductSales,
          periodFilter: value
        },
        active: true
      }
    }, () => this.getTopProductsSales());
  }


  /* TOP SELLERS  */

  getTopSellers() {
    this.props.getTopSellers({
      branchId: this.props.branchId,
      periodFilter: this.state.topSellers.periodFilter
    });
  }

  handleTopSellersFilter(value) {
    this.setState(prevState => {
      return {
        ...prevState,
        topSellers: {
          ...prevState.topSellers,
          periodFilter: value
        }
      }
    }, () => this.getTopSellers());
  }

  handleInventoryFilter(value) {
    this.setState(prevState => {
      return {
        ...prevState,
        inventory: {
          ...prevState.inventory,
          categoryFilter: value
        }
      }
    }, () => this.getInvetory());
  }

  render() {

    return (
      <div>
        {this.props.canViewDashboard ?
          <Dashboard
            {...this.props}
            handleTopProductSalesFilter={this.handleTopProductSalesFilter}
            handleTopSellersFilter={this.handleTopSellersFilter}
            handleSalesFilter={this.handleSalesFilter}
            handleInventoryFilter={this.handleInventoryFilter}
          /> :
          <OldHomePage />
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    orders: state.dashboard.orders,
    cashdrawer: state.dashboard.cashDrawer,
    sales: state.dashboard.sales,
    topProducts: state.dashboard.topProducts,
    topMembers: state.dashboard.topMembers,
    topSellers: state.dashboard.topSellers,
    timesheet: state.dashboard.timesheet,
    purchaseOrder: state.dashboard.purchaseOrders,
    inventory: state.dashboard.inventory,
    campaings: state.dashboard.campaings,
    branchId: state.common.branchId,
    authUser: state.common.authenticatedUser,
    userName: state.common.authenticatedUser ? state.common.authenticatedUser.userName : '',
    isMedical: state.common.applicationSettings.isMedical,
    storeManagerCanAccessDashboard: state.common.applicationSettings.storeManagerCanAccessDashboard,
    cachingProducts: state.common.applicationSettings.cachingProducts,
    sellableProducts: state.entity.sellableProductsAll,
    canViewDashboard: state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanViewDashboard"))
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getUserBranches: (userName) => dispatch(getUserBranches(userName)),
    getUserRolePageByName: (roleName) => dispatch(getUserRolePageByName(roleName)),
    selectStore: () => dispatch(selectStore()),
    getOrders: (branchId) => dispatch(getOrders(branchId)),
    getCashDrawer: (branchId) => dispatch(getCashDrawer(branchId)),
    getSales: (model) => dispatch(getSales(model)),
    getTopProductsSales: (model) => dispatch(getTopProductsSales(model)),
    getTopMembers: () => dispatch(getTopMembers()),
    getTopSellers: (model) => dispatch(getTopSellers(model)),
    getTimesheet: (branchId) => dispatch(getTimesheet(branchId)),
    getPurchaseOrdersDb: (branchId) => dispatch(getPurchaseOrdersDb(branchId)),
    getInvetory: (model) => dispatch(getInvetory(model)),
    getCampaignDb: (branchId) => dispatch(getCampaignDb(branchId)),
    getSellableProducts: (model) => dispatch(getSellableProducts(model)),
    setProductListEmpty: () => dispatch(setProductListEmpty())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
